import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl'
import { compose } from 'recompose'

import { RadioGroup, Radio, Input } from 'components/fields'
import { Note, Anchor } from 'components/misc'
import { SecurityPolicy } from 'components/modals'
import { PAYMENT_TYPES, DELIVERY_TYPES, CONFIGURATION_KEYS } from 'constants/enums'
import styles from './payment-comp.styl'
import { connect } from 'react-redux'
import { apiConfiguration } from '../../../helpers/decorators/api'


const enhance = compose(
  connect(({ api }) => ({
    configuration: api.configuration
  })),
  injectIntl,
  apiConfiguration()
)
class PaymentComp extends Component {
  static propTypes = {
    // onPaymentInitialization: React.PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    paymentOptions: PropTypes.any,
    errors: PropTypes.object,
    intl: PropTypes.object,
    values: PropTypes.object,
    onGetConfigurationValue: PropTypes.func.isRequired,
    configuration: PropTypes.object
  }

  componentDidMount = async () => {
    const { values } = this.props

    const organizationId =
      get(values, 'subOperatingAuthorityId') ||
      get(values, 'operatingAuthorityId') ||
      get(values, 'organizationId') ||
      get(values, 'naoId') ||
      1

    await this.props.onGetConfigurationValue(
      CONFIGURATION_KEYS.enablePaymentRefundPolicy.id,
      organizationId,
      true
    )
  }

  setValueOnline = () => {
    // this.props.onPaymentInitialization(this.props.values)
    this.setValue(PAYMENT_TYPES.online.id, {})
  }
  setValuePaypal = () => {
    // this.props.onPaymentInitialization(this.props.values)
    this.setValue(PAYMENT_TYPES.payPal.id, {})
  }
  setValueGlobalPayments = () => {
    // this.props.onPaymentInitialization(this.props.values)
    this.setValue(PAYMENT_TYPES.globalPayments.id, {})
  }
  setValueGlobalPaymentsWebpay = () => {
    this.setValue(PAYMENT_TYPES.globalPaymentsWebpay.id, {})
  }

  setValueOnlineManual = () => {
    // this.props.onPaymentInitialization(this.props.values)
    this.setValue(PAYMENT_TYPES.onlineManual.id, {})
  }
  setValueOffline = () => this.setValue(PAYMENT_TYPES.offline.id, {})
  setValueExempt = () => this.setValue(PAYMENT_TYPES.exempt.id, {})
  setValueDirectTransfer = () => this.setValue(PAYMENT_TYPES.directTransfer.id, {})

  setValue = (value, { currency }) => {
    const { change, paymentOptions } = this.props

    let actualAmount = 0

    if (
      [PAYMENT_TYPES.offline.id, PAYMENT_TYPES.onlineManual.id].includes(value)
    ) {
      actualAmount = paymentOptions.baseAmount
    } else if (value === PAYMENT_TYPES.online.id) {
      actualAmount = paymentOptions.amountMPG
    }

    change('awardFeeAmount', actualAmount)
    change(
      'awardFeeCurrency',
      currency || get(paymentOptions, 'currency.value')
    )
    change('paymentType.value', value)
  }

  handleManualPaymentLink = e => {
    e.preventDefault()

    let manualPaymentLink = get(
      this.props.paymentOptions,
      'nonMpgOnlinePaymentUrl'
    )

    if (manualPaymentLink && !manualPaymentLink.includes('http')) {
      manualPaymentLink = '//' + manualPaymentLink
    }

    window.open(manualPaymentLink, '_blank')
  }

  render() {
    const { values, paymentOptions, intl, configuration } = this.props

    const isRefundPolicyEnabled = get(configuration, `values[${CONFIGURATION_KEYS.enablePaymentRefundPolicy.id}].booleanValue`)

    // const exemptFromPaymentDescription = get(paymentOptions, 'exemptFromPaymentDescription')
    const exemptFromPaymentEnabled =
      get(paymentOptions, 'exemptFromPaymentEnabled') || false

    const onlineMastercardPaymentEnabled =
      get(paymentOptions, 'onlineMastercardPaymentEnabled') || false

    const onlineManualPaymentEnabled =
      get(paymentOptions, 'onlineManualPaymentEnabled') || false

    const onlinePayPalPaymentEnabled =
      get(paymentOptions, 'onlinePayPalPaymentEnabled') || false

    const onlineGPPaymentEnabled =
      get(paymentOptions, 'onlineGPPaymentEnabled') || false

    const onlineGPWebpayPaymentEnabled =
      get(paymentOptions, 'onlineGPWebpayPaymentEnabled') || false

    const directPaymentEnabled = get(
      paymentOptions,
      'directPaymentEnabled',
      false
    )

    const directTransferPaymentEnabled =
      get(paymentOptions, 'directTransferPaymentEnabled') || false

    const manualPaymentLink = get(paymentOptions, 'nonMpgOnlinePaymentUrl')
    const manualPaymentImageLink = get(paymentOptions, 'nonMpgOnlinePaymentImageUrl')
    const eletronicalConsent =
      get(values, 'consentDeliveryType.value') &&
      get(values, 'consentDeliveryType.value') ===
      DELIVERY_TYPES.ELECTRONICALLY.value

    return (
      <div className="row">
        <div className="col-xs-8">
          <div>
            <RadioGroup
              label="Payment type:"
              intlKey="label.payment_type"
              name="helpers.price"
              errors={this.props.errors}
              horizontal
              dataTestId="paymentMethodsRadioGroup"
            >
              {onlineGPPaymentEnabled &&
              <Radio
                name="helpers.price"
                value={PAYMENT_TYPES.globalPayments.id}
                label={
                  (<FormattedHTMLMessage
                    id="label.onlineGPPaymentDescription"
                    defaultMessage={get(paymentOptions, 'onlineGPPaymentDescription')}
                  />) ||
                  intl.formatMessage({
                    id: 'label.pay_online_global_payments',
                    defaultMessage: 'Pay online'
                  })
                }
                subLabel="You will be redirected to the Global Payments Gateway, where you can pay by your credit card."
                intlKeySub="label.you_will_be_redirected_to_the_global_payments"
                onChange={this.setValueGlobalPayments}
                dataTestId="gpPaymentSelector"
              />}
              {onlineGPWebpayPaymentEnabled &&
              <Radio
                name="helpers.price"
                value={PAYMENT_TYPES.globalPaymentsWebpay.id}
                label={
                  (<FormattedHTMLMessage
                    id="label.onlineGPWebpayPaymentDescription"
                    defaultMessage={get(paymentOptions, 'onlineGPWebpayPaymentDescription')}
                  />) ||
                  intl.formatMessage({
                    id: 'label.pay_online_global_webpay_payments',
                    defaultMessage: 'Pay online'
                  })
                }
                subLabel="You will be redirected to the GP Webpay Gateway, where you can pay by your credit card."
                intlKeySub="label.you_will_be_redirected_to_the_global_payments_wp"
                onChange={this.setValueGlobalPaymentsWebpay}
                dataTestId="gpWebpayPaymentSelector"
              />}
              {onlinePayPalPaymentEnabled &&
              <Radio
                name="helpers.price"
                value={PAYMENT_TYPES.payPal.id}
                label={
                  (<FormattedHTMLMessage
                    id="label.onlinePayPalPaymentDescription"
                    defaultMessage={get(paymentOptions, 'onlinePayPalPaymentDescription')}
                  />) ||
                  intl.formatMessage({
                    id: 'label.pay_online_paypal',
                    defaultMessage: 'Pay online'
                  })
                }
                subLabel="You will be redirected to the Payment Gateway, where you can pay by your credit card."
                intlKeySub="label.you_will_be_redirected_to_the_payment"
                onChange={this.setValuePaypal}
                dataTestId="payPalPaymentSelector"
              />}
              {onlineMastercardPaymentEnabled &&
              <Radio
                name="helpers.price"
                value={PAYMENT_TYPES.online.id}
                label={
                  (<FormattedHTMLMessage
                    id="label.onlineMastercardPaymentDescription"
                    defaultMessage={get(paymentOptions, 'onlineMastercardPaymentDescription')}
                  />) ||
                  intl.formatMessage({
                    id: 'label.pay_online_mastercard',
                    defaultMessage: 'Pay online'
                  })
                }
                subLabel="You will be redirected to the Payment Gateway, where you can pay by your credit card."
                intlKeySub="label.you_will_be_redirected_to_the_paypal_payment"
                onChange={this.setValueOnline}
                dataTestId="mastercardPaymentSelector"
              />}
              {(get(values, 'helpers.price') === PAYMENT_TYPES.online.id ||
                get(values, 'helpers.price') === PAYMENT_TYPES.payPal.id) &&
              <div>
                {get(values, 'helpers.isUnderAge') &&
                !eletronicalConsent &&
                <div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-6">
                      <div className={styles.transactionId}>
                        <Input
                          name="parentEmail"
                          label="Email"
                          intlKey="label.your_parent_email"
                          dataTestId="parentEmailInputPayment"
                        />
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className={styles.transactionId}>
                        <Input
                          name="confirmEmail"
                          label="Confirm email"
                          intlKey="label.confirm_email"
                        />
                      </div>
                    </div>
                  </div>
                </div>}
                 </div>}
              {onlineManualPaymentEnabled &&
              <Radio
                name="helpers.price"
                value={PAYMENT_TYPES.onlineManual.id}
                label={
                  (<FormattedHTMLMessage
                    id="label.onlineManualPaymentDescription"
                    defaultMessage=  {get(paymentOptions, 'onlineManualPaymentDescription')}
                  />) ||
                  intl.formatMessage({
                    id: 'label.pay_online',
                    defaultMessage: 'Pay online'
                  })
                }
                subLabel="You will be asked to type in your transaction ID."
                intlKeySub="label.you_will_type_trans_id"
                onChange={this.setValueOnlineManual}
              />}
              {get(values, 'helpers.price') === PAYMENT_TYPES.onlineManual.id && <div>
                {manualPaymentLink &&
                <Note margin="0 0 5px 30px">
                  <Anchor>
                    <a href="#" onClick={this.handleManualPaymentLink}>
                      <FormattedMessage
                        id="registration_participant.pay_online_here"
                        defaultMessage="Pay online (click on the link below, or use the QR code below)"
                      />
                    </a>
                  </Anchor>
                </Note>}
                <Anchor margin="0 0 8px 30px">
                  {/* QR CODE */}
                  {manualPaymentImageLink &&
                    <img
                      src={manualPaymentImageLink}
                      height={200}
                    />
                  }
                </Anchor>
                <div className="row">
                  <div className="col-xs-12 col-sm-6">
                    <div className={styles.transactionId}>
                      <Input
                        name="enteredTransactionId"
                        label="Your transaction Id"
                        intlKey="label.entered_transaction_id"
                      />
                    </div>
                  </div>
                </div>
              </div>}
              {directPaymentEnabled &&
              <Radio
                name="helpers.price"
                value={PAYMENT_TYPES.offline.id}
                label={
                  (<FormattedHTMLMessage
                    id="label.directPaymentDescription"
                    defaultMessage=  {get(paymentOptions, 'directPaymentDescription')}
                  />) ||
                  intl.formatMessage({
                    id: 'label.pay_award_leader_or_unit',
                    defaultMessage: 'Pay Award Leader or Unit'
                  })
                }
                subLabel="Bring required amount to your Award Leader or Award Coordinator in your Unit."
                intlKeySub="label.bring_required_amount_to_your_award_leader"
                onChange={this.setValueOffline}
              />}
              {directTransferPaymentEnabled &&
              <Radio
                name="helpers.price"
                value={PAYMENT_TYPES.directTransfer.id}
                label={
                  (<FormattedHTMLMessage
                    id="label.directTransferPaymentDescription"
                    defaultMessage=  {get(paymentOptions, 'directTransferPaymentDescription')}
                  />) ||
                  intl.formatMessage({
                    id: 'label.direct_money_transfer',
                    defaultMessage: 'Direct money transfer'
                  })
                }
                subLabel={
                  'Choose this option if you are sending your money from your bank account.'
                }
                intlKeySub="label.you_need_pay_to_nao_acc"
                onChange={this.setValueDirectTransfer}
              />}
              {exemptFromPaymentEnabled &&
              <Radio
                name="helpers.price"
                value={PAYMENT_TYPES.exempt.id}
                label={
                  (<FormattedHTMLMessage
                    id="label.exemptFromPaymentDescription"
                    defaultMessage=  {get(paymentOptions, 'exemptFromPaymentDescription')}
                  />) ||
                  intl.formatMessage({
                    id: 'label.payment_not_required',
                    defaultMessage: 'Payment Not Required'
                  })
                }
                subLabel={
                  "If you are from orphanage, you don't have to pay for the Award."
                }
                intlKeySub="label.if_you_are_from_orphanage"
                onChange={this.setValueExempt}
              />}
            </RadioGroup>

            {isRefundPolicyEnabled && <div style={{ marginBottom: 16 }}>
              <div className="row">
                <div className="col-xs-12 col-sm-6">
                  <div className={styles.transactionId}>
                    <SecurityPolicy
                      organizationId={get(values, 'organizationId')}
                    />
                  </div>
                </div>
              </div>
            </div>}

          </div>
        </div>
      </div>
    )
  }
}

export default enhance(PaymentComp)
